<template>
  <div id="app">
    <router-view>
    </router-view>
  </div>
</template>
<script>
export default {
  data () {
    return {

    }
  },
  watch: {

  }
}
</script>
<style lang='scss'>
.form {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  .form-item {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    height: 35px;
    margin-bottom: 10px;
    margin-right: 10px;
    font-size: 14px;
    .label {
      flex-wrap: nowrap;
    }
    .value {
      height: 35px;
      .el-input__inner {
        height: 35px;
      }
    }
  }
}
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>
<style lang='scss'>
#app {
  overflow-x: hidden;
}
:deep(.el-drawer__header) {
  margin-bottom: 10px;
  color: #f56c6c;
}
:deep(.el-drawer__body) {
  margin: 10px;
}
::-webkit-scrollbar {
  width: 6px !important;
  height: 6px;
  cursor: pointer;
  margin: 0 !important;
  padding: 0 !important;
}
::-webkit-scrollbar-track {
  background-color: #f6f6f6;
  box-shadow: none;
  cursor: pointer;
  margin: 0 !important;
  padding: 0 !important;
}
::-webkit-scrollbar-button {
  display: block;
  background-color: #f6f6f6;
  width: 0px;
  cursor: pointer;
  margin: 0 !important;
  padding: 0 !important;
}
::-webkit-scrollbar-thumb {
  background-color: rgba(87, 193, 255, 0.5);
  border-radius: 3px;
  cursor: pointer;
  margin: 0 !important;
  padding: 0 !important;
}
// .vue-treeselect__control {
//   height: 30px !important;
// }
// .vue-treeselect--single .vue-treeselect__input-container {
//   height: 30px !important;
// }
// .vue-treeselect__single-value{
//   height: 30px !important;
// }
/deep/.el-drawer__header {
  margin-bottom: 10px;
  font-size: 24px;
  font-weight: bold;
  color: #ff862f;
}
/deep/.el-drawer__body {
  overflow-y: scroll;
}
</style>
